import {
    DISCOVER_PRIVACY,
    discoverPrivacyToCanonicalVisibility,
    normalizeDiscoverPrivacyValue,
} from '../constants/visibility';

const NON_PUBLIC_PRIVACY_FALLBACK = DISCOVER_PRIVACY.PRIVATE;

export function normalizeDiscoverPrivacy(value, fallback = NON_PUBLIC_PRIVACY_FALLBACK) {
    return normalizeDiscoverPrivacyValue(value, fallback);
}

export function toCanonicalVisibility(value) {
    return discoverPrivacyToCanonicalVisibility(value, NON_PUBLIC_PRIVACY_FALLBACK);
}

export function toDiscoverPrivacy(value, fallback = NON_PUBLIC_PRIVACY_FALLBACK) {
    return normalizeDiscoverPrivacyValue(value, fallback);
}

export function isPublicDiscoverPrivacy(value) {
    return normalizeDiscoverPrivacy(value) === DISCOVER_PRIVACY.PUBLIC;
}
